import { Currency } from "../../Business/dto/Brief";
import { ExternalDataPicker } from "./ExternalDataPicker";
import { DataKey } from "../../Business/dto/ExternalSystemElement";
import { faCoins } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

interface CurrencyPickerProps {
    setSelectedCurrency: (currency: Currency) => void;
    required?: boolean;
    value: Currency | undefined;
}

export const CurrencyPicker = (props: CurrencyPickerProps) => {
    const { t } = useTranslation();
    
    return (
        <>
                <ExternalDataPicker
                    setSelectedData={props.setSelectedCurrency}
                    placeholder={t("txt_currency")}
                    dataKey={DataKey.Currency}
                    icon={faCoins}
                    controlId="currencyPicker"
                    required={props.required}
                    displayCode
                    value={props.value ? [props.value] : []}
                />
        </>
    );
}